import { ref, watch, onBeforeUnmount } from 'vue';

const LIVE_REFRESH_STORAGE_KEY = 'chatwoot_live_reports_enabled';

// Global shared reactive state for live refresh across all report containers
export const isLiveRefreshEnabled = ref(
  localStorage.getItem(LIVE_REFRESH_STORAGE_KEY) !== 'false'
);

export const toggleLiveRefresh = value => {
  const nextVal =
    value !== undefined ? Boolean(value) : !isLiveRefreshEnabled.value;
  isLiveRefreshEnabled.value = nextVal;
  try {
    localStorage.setItem(LIVE_REFRESH_STORAGE_KEY, String(nextVal));
  } catch {
    // Ignore localStorage errors
  }
};

export const useLiveRefresh = (callback, interval = 60000) => {
  const timeoutId = ref(null);
  let isActive = false;

  const startRefetching = () => {
    isActive = true;
    stopRefetching();
    if (!isLiveRefreshEnabled.value) return;

    timeoutId.value = setTimeout(async () => {
      if (!isLiveRefreshEnabled.value || !isActive) return;
      await callback();
      if (isActive && isLiveRefreshEnabled.value) {
        startRefetching();
      }
    }, interval);
  };

  const stopRefetching = () => {
    if (timeoutId.value) {
      clearTimeout(timeoutId.value);
      timeoutId.value = null;
    }
  };

  watch(isLiveRefreshEnabled, enabled => {
    if (enabled && isActive) {
      startRefetching();
    } else {
      stopRefetching();
    }
  });

  onBeforeUnmount(() => {
    isActive = false;
    stopRefetching();
  });

  return {
    startRefetching,
    stopRefetching,
    isLiveRefreshEnabled,
    toggleLiveRefresh,
  };
};
